const AR = {
  acceptRequest: "قبول الطلب",
  accessDetail: "تفاصيل الوصول",
  accessoryUnavailable: "الملحقات غير متوفرة",
  actions: "إجراءات",
  activity: "نشاط",
  add: "إضافة",
  addAgency: "إضافة وكالة",
  addAgencyInfoBullet1: "طلب عروض أسعار وتقديم طلبات مباشرة.",
  addAgencyInfoBullet2: "الاستفادة من أسعار العقود الإطارية الحالية.",
  addAgencyInfoBullet3: "الوصول إلى الموارد التي ستربطها بها.",
  addAgencyInfoTitle: "بإضافة هذه الوكالة، سيتمكن عملاؤك من:",
  addDocuments: "إضافة مستندات",
  addEvent: "إضافة حدث",
  addFile: "إضافة ملف",
  addInformation: "إضافة معلومات",
  additionalInformation: "معلومات إضافية",
  addMessageToCustomer: "إضافة رسالة للعميل",
  addNewDocument: "إضافة مستند جديد",
  addParticipant: "إضافة مشارك",
  addResource: "إضافة مورد",
  address: "العنوان",
  addUser: "إضافة مستخدم",
  agencies: "الوكالات",
  agency: "وكالة",
  agencyArchived: "تم أرشفة الوكالة",
  agencyCreated: "تم إنشاء الوكالة",
  agencyEmailDescription:
    "ستُرسل جميع إشعارات طلبات الوكالة (طلب عرض سعر، بدء الإيجار، حدث، إرجاع...) إلى مستخدمي الوكالة وكذلك إلى هذا البريد الإلكتروني.",
  agencyIsRequired: "الوكالة مطلوبة",
  agencyName: "اسم الوكالة",
  agencyUpdated: "تم تحديث الوكالة",
  allFilesUpToDate: "جميع الملفات محدثة",
  allMyOrders: "جميع طلباتي",
  allResources: "جميع الموارد",
  alreadyCustomer: "هل أنت عميل بالفعل؟",
  analytics: "تحليلات",
  anErrorOccurred: "حدث خطأ",
  apiStatus: "حالة API",
  applicant: "مقدم الطلب",
  applicationVersion: "إصدار التطبيق",
  archive: "أرشيف",
  archive_one: "{{count}} أرشيف",
  archive_other: "{{count}} أرشيفات",
  archiveAgency: "أرشفة الوكالة",
  archiveAgencyConfirmation: "هل أنت متأكد من أنك تريد أرشفة الوكالة {{name}}؟ سيتم أرشفة جميع العقود المرتبطة وإلغاء طلبات الحجز المعلقة.",
  archived: "مؤرشفة",
  areYouAConstructionCompany: "هل أنت شركة مقاولات؟",
  areYouSureYouWantDetachResource: "هل أنت متأكد أنك تريد فصل المورد من هذا الطلب؟",
  areYouSureYouWantDetachUser: "هل أنت متأكد أنك تريد فك ارتباط هذا المستخدم من الوكالة؟ سيتم إخطار هذا المستخدم عبر البريد الإلكتروني.",
  areYouSureYouWantToDelete: "هل أنت متأكد أنك تريد الحذف؟",
  areYouSureYouWantToDeleteWithItem: "هل أنت متأكد أنك تريد حذف {{item}}؟",
  article: "عنصر",
  articleAccess: "وصول العنصر",
  articleCategory: "الفئة",
  articleEquipmentUpdated: "تم تحديث معدات العنصر",
  articleInformation: {
    message: "اختر آلة من أسطولك الداخلي أو مشغّلًا",
    warningDescription: "معلومات المعدات مفقودة. يرجى تقديم المستندات والمعلومات المطلوبة قبل بدء الإيجار.",
    warningTitle: "معلومات المعدات مفقودة",
  },
  articleNameIsRequired: "اسم العنصر مطلوب",
  articles: "عناصر",
  assignment: "تعيين",
  associatedMachine: "الآلة المرتبطة",
  attachAResource: "اختيار مورد",
  attachResource: "ربط مورد",
  availability: "التوفر",
  available: "متوفر",
  backToLogin: "العودة لتسجيل الدخول",
  beginning: "البداية",
  between: "بين",
  billing: "الفوترة",
  billingDetailsAssociatedWithThisOrder: "تفاصيل الفوترة المرتبطة بهذا الطلب",
  billings: "الفواتير",
  booking: {
    addAnItem: "إضافة عنصر",
    automaticExtension: "تمديد تلقائي",
    bankingHolidays: "العطل الرسمية",
    date: " التاريخ",
    day: "اليوم",
    days: "الأيام",
    fromDate: "من التاريخ",
    saturday: "السبت",
    sunday: "الأحد",
    toDate: "إلى التاريخ",
    useOn: "الاستخدام في:",
  },
  bookingDate: "من {{fromDate}} إلى {{toDate}}",
  bookingEnd: "نهاية الحجز",
  bookingStart: "بداية الحجز",
  bookingStartTomorrow: "يبدأ الحجز غدًا",
  bookingStartTomorrowMessage: "تأكد من أن كل شيء جاهز للتسليم، مع احترام متطلبات العميل وإدراج الملحقات المطلوبة إذا لزم الأمر.",
  bookings: "الحجوزات",
  brand: "العلامة التجارية",
  brandIsRequired: "العلامة التجارية مطلوبة",
  breadcrumbs: {
    booking: {
      requests: "رقم {{id}}",
    },
  },
  by: "بواسطة",
  byFile: "عن طريق الملف",
  cancel: "إلغاء",
  canceled: "ملغى",
  category: "الفئة",
  categoryName: "اسم الفئة",
  ceCertificate: "شهادة CE",
  changePasswordAccount: "تغيير كلمة مرور حسابك في Tracktor",
  chat: "محادثة",
  clickToUpload: "انقر للتحميل",
  client: "عميل",
  clientRequest: "طلب العميل",
  clients: "العملاء",
  clientWillBeNotifiedByEmail: "سيتم إخطار المستخدم المدعو عبر البريد الإلكتروني.",
  close: "إغلاق",
  closed: "مغلق",
  closedAt: "أغلق في {{date}}",
  closedAtIncidentAlert: "أغلق في {{date}} بواسطة {{by}}",
  closeTheIncident: "إغلاق الحادث",
  code: "رمز",
  codeOrKeysLocation: "رمز أو موقع المفاتيح",
  commandPosts: "مراكز القيادة",
  company: "شركة",
  completed: "مكتمل",
  confirm: "تأكيد",
  confirmed: "تم التأكيد",
  contactAction: "تواصل",
  contacts: "جهات الاتصال",
  continue: "متابعة",
  couldNotFindBookingItem: "تعذر العثور على عنصر الحجز",
  countryCode: "رمز الدولة",
  createAPasswordForYourAccount: "أنشئ كلمة مرور لحسابك",
  createNewResource: "إنشاء مورد جديد",
  createNewUser: "إنشاء مستخدم جديد",
  createYourFirstConversation: "أنشئ محادثتك الأولى",
  currentApiVersion: "إصدار API الحالي",
  currentApiVersionUsed: "إصدار API المستخدم",
  darkMode: "الوضع الداكن",
  darkTheme: "سمة داكنة",
  dashboard: "لوحة التحكم",
  dataSheet: "ورقة البيانات",
  date: {
    endDate: "تاريخ الانتهاء",
    startDate: "تاريخ البدء",
  },
  dates: "التواريخ",
  dayCount_one: "{{count}} يوم",
  dayCount_other: "{{count}} أيام",
  deals: "العروض",
  dealsView: {
    detailed: "مفصل",
    grouped: "مجمّع",
    kanban: "كانبان",
    list: "قائمة",
    planning: "تخطيط",
  },
  delete: "حذف",
  deleteBookingFileMessage: "هل أنت متأكد أنك تريد حذف هذا الملف من الحجز؟",
  deleteConversation: "حذف المحادثة",
  deleteFile: "حذف الملف",
  deleteFileConfirmation: "حذف الملف لا يمكن التراجع عنه. هل أنت متأكد أنك تريد المتابعة؟",
  deleteResource: "حذف المورد",
  deleteResourceConfirmation: "حذف المورد لا يمكن التراجع عنه وسيؤدي إلى حذف جميع الملفات المرتبطة به. هل أنت متأكد أنك تريد المتابعة؟",
  delivery: "التسليم",
  deliveryAndReturn: "التسليم والإرجاع",
  deliveryTimeConstraint: "قيد وقت التسليم",
  designation: "التسمية",
  detach: "فك الارتباط",
  detachResource: "فصل المورد",
  detachUser: "فك ارتباط المستخدم",
  detachUserSuccessfully: "تم فك ارتباط المستخدم بنجاح",
  document: "مستند",
  documentAdded: "تمت إضافة المستند",
  documentDeleted: "تم حذف المستند",
  documentExp: "انتهاء المستند",
  documentIssue_one: "{{count}} مستند مطلوب",
  documentIssue_other: "{{count}} مستندات مطلوبة",
  documentIssueTooltip_one: "{{count}} مستند مفقود أو منتهي الصلاحية",
  documentIssueTooltip_other: "{{count}} مستندات مفقودة أو منتهية الصلاحية",
  documentMissing_one: "{{count}} مستند مفقود",
  documentMissing_other: "{{count}} مستندات مفقودة",
  documentName: "اسم المستند",
  documents: "المستندات",
  documentsOk: "المستندات سليمة",
  documentType: "نوع المستند",
  documentUpdated: "تم تحديث المستند",
  edit: "تعديل",
  editInfoDocument: "تعديل معلومات المستند",
  editMyPassword: "تعديل كلمة المرور الخاصة بي",
  editResource: "تعديل المورد",
  editUser: "تعديل المستخدم",
  email: "البريد الإلكتروني",
  emailSent: "تم إرسال البريد الإلكتروني",
  emailSentForgotPassword: "تم إرسال بريد إلكتروني لإعادة تعيين كلمة المرور الخاصة بك.",
  emptyBooking: "ليس لديك حجوزات قادمة",
  emptyBookingMissing: "ليس لديك طلبات فائتة",
  emptyState: {
    noDealsFound: " ليس لديك أي طلبات بعد",
    noDealsFoundDescription: "ستظهر طلباتك الجديدة في هذا الجدول.",
    pageNotFoundDescription: "الصفحة التي تبحث عنها غير موجودة. يرجى التحقق من الرابط أو العودة إلى الصفحة السابقة.",
    returnToOrders: "العودة إلى الطلبات",
  },
  end: "النهاية",
  enterTheCode: "أدخل الرمز",
  enterToSend: "↵ Enter للإرسال · ⇧ Shift+↵ Enter لسطر جديد",
  enterYourCode: "أدخل رمزك",
  enterYourMessage: "أدخل رسالتك",
  entity: "الكيان",
  equipment: "معدات",
  equipmentInformation: {
    maximumPlates: "الحمولة القصوى على اللوح (طن)",
    sizePlates: "حجم ألواح التوزيع (م²)",
    skid: "الضغط الأقصى تحت لوح التوزيع (طن/م²)",
  },
  equipmentNotOffered: "المعدات غير معروضة",
  error: {
    missingArticle: "المادة مفقودة في الطلب، يرجى التحقق من الطلب.",
    missingDates: "التواريخ مفقودة في الطلب، يرجى التحقق من الطلب.",
    missingQuantity: "الكمية مفقودة في الطلب، يرجى التحقق من الطلب.",
    missingUnitPrice: "سعر الوحدة مفقود في الطلب، يرجى التحقق من الطلب.",
    noBookingFound: "لم يتم العثور على حجوزات",
    noClientFoundForThisRequest: "لم يتم العثور على عميل لهذا الطلب",
    pleaseFillFields: "يرجى ملء جميع الحقول المطلوبة بشكل صحيح.",
    pleaseSelectArticleBeforeAddingNewOne: "يرجى اختيار عنصر قبل إضافة عنصر جديد.",
    positiveValueOnly: " القيمة الموجبة فقط مسموح بها",
    resourceMustBeSelected: "يجب اختيار مورد",
    selectDates: "يرجى اختيار التواريخ الصحيحة",
    shouldBeANumber: "يجب أن يكون رقمًا",
    someRequestDataAreMissing: "بعض بيانات الطلب مفقودة، يرجى التحقق من الطلب.",
    unknownError: "خطأ غير معروف، يرجى المحاولة مرة أخرى",
  },
  error404: "خطأ 404",
  errorLoadingRequests: "حدث خطأ أثناء تحميل الطلبات",
  escape: "خروج",
  eventStatus: {
    accepted: "تم قبول طلب الإيجار",
    canceled: "تم إلغاء طلب الإيجار",
    refused: "تم رفض طلب الإيجار",
    sent: "تم استلام طلب الإيجار",
  },
  eventUpdated: "تم تحديث الحدث",
  expirationDate: "تاريخ الانتهاء",
  expired: "منتهي الصلاحية",
  file: "الملف",
  fileAddedSuccessfully: "تمت إضافة الملف بنجاح",
  fileArchivedSuccessfully: "تم أرشفة الملف بنجاح",
  fileDeletedSuccessfully: "تم حذف الملف بنجاح",
  fileHasBeenUploaded: "تم تحميل الملف",
  fileName: "اسم الملف",
  fileStatus: {
    expired: "منتهي الصلاحية",
    expires_soon: "سينتهي قريبًا",
    up_to_date: "محدث",
  },
  files: "الملفات",
  filesNotUpToDate: "بعض الملفات ليست محدثة",
  fileType: "نوع الملف",
  fileUnarchivedSuccessfully: "تم إلغاء أرشفة الملف بنجاح",
  finish: "إنهاء",
  finishDayCount: "تنتهي هذه المدة خلال {{count}} يومًا",
  finishToday: "ينتهي اليوم",
  finishTomorrow: "ينتهي غدًا",
  firstName: "الاسم الأول",
  flatRate: "سعر ثابت",
  fleetNumber: "رقم الأسطول",
  forgottenPassword: "نسيت كلمة المرور",
  forgottenPasswordSubtitle: "أدخل بريدك الإلكتروني. سنرسل لك رابطًا لإعادة تعيين كلمة المرور",
  form: {
    constraint: {
      password: "يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل وحرف كبير واحد",
    },
    validation: {
      required: "هذا الحقل مطلوب",
    },
  },
  generalTerms: "الشروط العامة",
  getSupport: "احصل على الدعم",
  giveFeedback: " أعطِ ملاحظات",
  globalSearchPlaceholder: "أدخل رقم صفقة أو اسم عنصر",
  happyToSeeYouAgain: "سعداء برؤيتك مجددًا!",
  help: "مساعدة",
  helperText: {
    onlyImageFilesAreAllowed: "يسمح فقط بملفات .png و .jpeg و .pdf",
  },
  history: "السجل",
  home: "الرئيسية",
  icon: "أيقونة",
  identity: "الهوية",
  identityCard: "بطاقة الهوية",
  import: "استيراد",
  importFile: "استيراد ملف",
  incidentAddedSuccessfully: "تمت إضافة الحادث بنجاح",
  incidentClosed: "تم إغلاق الحادث",
  incidentOpened: "تم فتح الحادث",
  indicateCodeOrKeysLocation: "حدد الرمز أو موقع المفاتيح",
  information: "معلومات",
  informations: "معلومات",
  inProgress: "قيد التنفيذ",
  instructionManual: "دليل التعليمات",
  insurance: "تأمين",
  internalCode: "الرمز الداخلي",
  internalCodeIsRequired: "الرمز الداخلي مطلوب",
  invoice: "فاتورة",
  irreversibleAction: "هذا الإجراء لا يمكن التراجع عنه",
  key: "مفتاح",
  keyLocation: "موقع المفتاح",
  keys: "مفاتيح",
  language: "اللغة",
  lastName: "اسم العائلة",
  linkDocuments: "ربط المستندات",
  linkDocumentsToBooking: "المستندات المرئية للعميل",
  list: "قائمة",
  logIn: "سجّل الدخول",
  login: "تسجيل الدخول",
  logout: "تسجيل الخروج",
  machine: "آلة",
  machineRegistration: "تسجيل الآلة",
  mail: "البريد",
  maintenanceLog: "سجل الصيانة",
  makeAnOffer: "تقديم عرض",
  material: "المواد",
  materialDropOffPoint: "نقطة تسليم المواد",
  messagePlaceholder: "الحمل الأقصى على الزلاجة (طن)، أبعاد ألواح التوزيع (م²)…",
  messages: "الرسائل",
  messageToCustomer: "رسالة للعميل",
  missed: "فائت",
  missingRole: "دور مفقود",
  modifyMyOffer: "تعديل عرضي",
  modifyOffer: "تعديل العرض",
  myProfile: "ملفي الشخصي",
  name: "الاسم",
  newConversation: "محادثة جديدة",
  newDate: "تاريخ جديد",
  newDateProposal: "متاح من تاريخ قريب آخر",
  newDocument: "مستند جديد",
  newMessage: "رسالة جديدة",
  newMessageCount_one: "رسالة جديدة {{count}}",
  newMessageCount_other: "{{count}} رسائل جديدة",
  newPassword: "كلمة مرور جديدة",
  newPasswordConfirm: "تأكيد كلمة المرور الجديدة",
  newResourceCreated: "تم إنشاء المورد الجديد!",
  newResourceCreatedDetails: "قم بتحميل المستندات وتواريخ صلاحيتها.",
  next: "التالي",
  nextAssignment: "المهمة التالية",
  no: "لا",
  noAgenciesFound: "لم يتم العثور على وكالات",
  noAvailability: "لا يوجد توفر ولا يمكن التنازل",
  noDocumentsFound: "لم يتم العثور على مستندات",
  noEvents: "لا توجد أحداث",
  noFilesAttached: "لا توجد ملفات مرفقة",
  noNameFound: "لم يتم العثور على اسم",
  noOrderFound: "لم يتم العثور على طلب مرتبط بهذا العنصر",
  notAvailable: "غير متوفر",
  notes: "ملاحظات",
  notFound: "الصفحة التي تبحث عنها غير موجودة.",
  notFoundRedirection: "يرجى التحقق من الرابط أو العودة إلى الصفحة السابقة.",
  noUsersFound: "لم يتم العثور على مستخدمين",
  num: "رقم",
  numberOfDays: "العربية : عدد الأيام",
  numberParc: "رقم الحديقة",
  numberParcShort: "رقم أسطول",
  offerSendTo: "تم إرسال عرضك إلى {{name}}",
  offerSendToDetails: "سيتم إعلامك بمجرد موافقة عميلك على العرض.",
  onboarding: {
    featureRequests: {
      step1Description: "يرى العملاء على Tracktor فورًا المورّدين الأقرب إلى موقع مشروعهم، مصنّفين حسب المسافة وأسعار العقود الإطارية.",
      step1Title: "زِد من إيراداتك",
      step2Description: "املأ عرض السعر وأرسله. من خلال الرد بسرعة وبسعر منافس، تزيد من فرص اختيارك من قبل العميل!",
      step2Title: "تردّون خلال بضع نقرات فقط",
    },
  },
  open: "فتح",
  openFullPage: "فتح في صفحة كاملة",
  openFullScreen: "فتح في وضع ملء الشاشة",
  operator: "المشغل",
  operatorDocExp: "وثيقة مشغل منتهية",
  operatorDocKo: "وثائق المشغل غير صالحة",
  operatorDocMissing_one: "{{count}} وثيقة مشغل مفقودة",
  operatorDocMissing_other: "{{count}} وثائق مشغل مفقودة",
  operatorDocument: "مستند المشغل",
  order: "طلب",
  orderHistory: "سجل الطلبات",
  orderSummary: "ملخص الطلب",
  orders: "الطلبات",
  other: "أخرى",
  oups: "عذرًا!",
  overview: "نظرة عامة",
  pageNotFound: "الصفحة غير موجودة",
  participants: "المشاركون",
  password: "كلمة المرور",
  passwordSetSuccessfully: "تم تحديث كلمة المرور الخاصة بك",
  passwordsNotMatching: "كلمتا المرور غير متطابقتين",
  passwordUpdated: "تم تحديث كلمة المرور الخاصة بك",
  payments: "المدفوعات",
  periodicGeneralInspection: "فحص عام دوري (PGI)",
  phone: "الهاتف",
  phoneNumber: "رقم الهاتف",
  planning: "التخطيط",
  pleaseSetAPassword: "يرجى تعيين كلمة مرور",
  price: "السعر",
  priceExVAT: "بدون ضريبة القيمة المضافة",
  profile: "ملفي الشخصي",
  profileUpdated: "تم تحديث ملفك الشخصي",
  purchaseOrder: "أمر شراء",
  purchaseOrderNumber: "رقم أمر الشراء",
  quantity: "الكمية",
  quote: "عرض سعر",
  reason: "السبب",
  received: "تم الاستلام",
  refuse: "رفض",
  refused: "مرفوض",
  refusedBookingRequestMessage: "بتأكيد رفض طلب الحجز هذا، لن تتمكن من قبوله لاحقًا.",
  refusedTheBooking: "تم رفض الطلب",
  refuseRequest: "رفض الطلب",
  releaseNotRequested: "لم يطلب العميل بعد الإنهاء",
  releaseRequestedForDate: "تم طلب الإنهاء بتاريخ {{date}}",
  reload: "إعادة تحميل",
  rentalRequests: "الطلبات",
  reopenTheIncident: "إعادة فتح الحادث",
  replace: "استبدال",
  request: "طلب",
  requestMissedAlert: {
    button: "العودة إلى طلباتي",
    description1: "أرسل العميل هذا الطلب إلى عدة موردين وقبل أحد عروضهم.",
    description2: "على منصة Tracktor، يرد الموردون في المتوسط خلال أقل من ساعة: كن سريع الاستجابة لتعظيم فرصك في الحصول على فرص مستقبلية.",
    redirection: "👉 اكتشف المزيد حول بحث الموردين على Tracktor",
    title: "طلبات فائتة",
  },
  requestOfferAlertInfoDescription: "الرد على كل طلب (حتى بالرفض) يزيد من فرص إعادة التواصل مع هذا العميل بنسبة 65٪.",
  requestOfferAlertInfoTitle: "لا تفوت أي فرصة",
  requestStatus: {
    expired: "منتهي الصلاحية",
    proposed: "مقترح",
    refused: "مرفوض",
    toTreat: "قيد المعالجة",
  },
  requests: "الطلبات",
  requestWithID: "الطلبات رقم {{id}}",
  required: "مطلوب",
  reservation: "حجز",
  reservationRequestAccepted: "تم قبول طلب الحجز، وتم إنشاء الطلبية",
  reservationRequestInfo: "بقبولك، سيتم تحويل هذا الطلب تلقائيًا إلى طلبية بالشروط المذكورة أعلاه. ستظهر في طلبياتكم وسيتم إعلام العميل.",
  resetInitialRequest: "إعادة تعيين الطلب الأولي",
  resetPassword: "إعادة تعيين كلمة المرور",
  resource: "مورد",
  resourceAddedSuccessfully: "تمت إضافة المورد بنجاح",
  resourceCreated: "تم إنشاء الموارد",
  resourceDetachedSuccessfully: "تم فصل المورد بنجاح",
  resourceEmptyState: {
    button: "أضف أول مورد لك",
    dialogContentText: "أضف عدة موارد دفعة واحدة عن طريق استيراد ملف (CSV، XLS، XLSX، PDF...) أو أضف مواردك يدويًا.",
    dialogPrimaryButton: "إضافة يدويًا",
    dialogSecondaryButton: "استيراد ملف",
    dialogSuccessContentText: "جاري معالجة مواردك. ستتوفر قريبًا في مساحتك وسيتم إرسال تأكيد عبر البريد الإلكتروني.",
    dialogSuccessTitle: "تم نقل الموارد",
    dialogTitle: "اختر طريقتك",
    listSubtitle1: "أضف موردًا جديدًا إلى مساحتك",
    listSubtitle2: "وحدد تواريخ الصلاحية",
    listSubtitle3: "سيتم إرسال جميع المستندات إلى العميل",
    listTitle1: "حفظ مورد",
    listTitle2: "إضافة مستندات",
    listTitle3: "تعيينه إلى أمر",
    title: "أضف أول مورد لك وسهّل إدارة طلباتك",
  },
  resourceName: "اسم المورد",
  resourcePhoto: "صورة المورد",
  resourcePhotoHelperText: "PNG أو JPG (بحد أقصى 5 ميجابايت)",
  resourceSearchPlaceholder: "اكتب للبحث (الطراز، رقم الأسطول)",
  resources: "الموارد",
  resourceUpdated: "تم تحديث الموارد",
  resourceUpdatedSuccessfully: "تم تحديث المورد بنجاح",
  respondToDemand: "الرد على الطلب",
  return: "إرجاع",
  returnTo: "العودة إلى",
  role: "الدور",
  save: "حفظ",
  saveChanges: "حفظ التغييرات",
  search: "بحث",
  searchContacts: "البحث عن جهات اتصال",
  searchInApp: "البحث في التطبيق",
  see: "عرض",
  seeDetail: "عرض التفاصيل",
  seeOffer: "عرض العرض",
  seeTheLines: "عرض السطور",
  seeTheResource: "عرض المورد",
  selectAnAgency: "اختر وكالة",
  selectAnAgencyToAttachCategory: "اختر وكالة لإرفاق الفئة",
  selectAnotherResource: "اختر موردًا آخر",
  selectDocumentType: "اختر نوع المستند",
  selectExpirationDate: "اختر تاريخ الانتهاء",
  selectResource: "اختر مورد",
  selectResourceWarning: "باختيارك هذا المورد، فإنك تؤكد أنه يلبي احتياجات العميل. سيتم إشعار العميل عبر البريد الإلكتروني.",
  send: "إرسال",
  sendOffer: "إرسال العرض",
  sent: "تم الإرسال",
  serialNumber: "الرقم التسلسلي",
  service: "خدمة",
  settings: "الإعدادات",
  siret: "SIRET / رقم DNS",
  siretMustBe14Characters: "يجب أن يتكون رقم SIRET من 14 حرفًا بالضبط",
  sorenAnnouncement: {
    badge: "قريباً Soren",
    badgeSwitched: "الآن Soren",
    badgeSwitchedTooltip: "Tracktor أصبحت Soren — اعرف المزيد",
    badgeTooltip: "Tracktor تصبح Soren — اعرف المزيد",
    gotIt: "فهمت",
    readArticle: "قراءة الإعلان",
    story: {
      goToCard: "البطاقة {{count}}",
      nextCard: "البطاقة التالية",
      previousCard: "البطاقة السابقة",
      switchTitle: "Tracktor يغيّر اسمه بحلول {{date}}.",
      switchTitlePast: "Tracktor غيّر اسمه في {{date}}.",
      switchTitleToday: "Tracktor يغيّر اسمه اليوم.",
      thanksBody: "على آلاتكم وفرقكم وثقتكم.",
      thanksBodyOrders: "{{number}} طلبات معاً. على آلاتكم وفرقكم وثقتكم.",
      thanksBodyOrders_one: "طلب واحد معاً. على آلاتكم وفرقكم وثقتكم.",
      thanksBodyOrders_other: "{{number}} طلباً معاً. على آلاتكم وفرقكم وثقتكم.",
      thanksTitle: "شكراً يا {{name}}.",
      thanksTitleAnonymous: "شكراً.",
    },
    unchanged: {
      accessTitle: "نفس بيانات الدخول",
      contactsTitle: "نفس جهات الاتصال",
      ordersTitle: "نفس الطلبات والعملاء",
      title: "لا شيء يتغير سوى الاسم والشعار.",
    },
  },
  startDayCount: "يبدأ خلال {{count}} يوم",
  startToday: "يبدأ اليوم",
  startTomorrow: "يبدأ غدًا",
  status: "الحالة",
  supplier: "المورّد",
  supplierComment: "تعليق المورد",
  TECHNICAL_SHEET: "ورقة فنية",
  theBookingRequestHasBeenAccepted: "تم إرسال عرضك",
  theBookingRequestHasBeenRefused: "تم رفض طلب الحجز",
  to: "إلى",
  to_add: "لإضافة",
  toAdd: "لإضافة",
  toCome: "قادم",
  toDo: "للقيام به",
  today: "اليوم",
  tokenVerification: "التحقق من الرمز",
  total: "الإجمالي",
  totalHT: "الإجمالي بدون ضريبة",
  toUpdate: "للتحديث",
  type: "نوع",
  typeToSearch: "اكتب للبحث",
  unarchive: "إلغاء الأرشفة",
  units: {
    DAYS_one: "{{count}} يوم",
    DAYS_other: "{{count}} أيام",
    HOURS_one: "{{count}} ساعة",
    HOURS_other: "{{count}} ساعات",
    KM: "{{count}} كم",
    null: "{{count}} ",
    unit: "وحدة",
    units: "وحدات",
    units_one: "{{count}} وحدة",
    units_other: "{{count}} وحدات",
  },
  up_to_date: "محدث",
  uploadFile: "تحميل ملف",
  upToDate: "محدث",
  userHasBeenAttachedToAgency: "تم ربط المستخدم بالوكالة",
  users: "المستخدمون",
  usersActions: {
    archiveUser: "أرشفة المستخدم",
    archiveUserSuccessfully: "تمت أرشفة المستخدم بنجاح",
    areYouSureYouWantToArchiveThisUser:
      "هل أنت متأكد من أنك تريد أرشفة هذا المستخدم؟ لن يكون لهذا المستخدم إمكانية الوصول إلى مساحة الوكالة وسيتم إخطاره عبر البريد الإلكتروني.",
    unarchiveUser: "إلغاء أرشفة المستخدم",
    unarchiveUserDescription: "من خلال إلغاء أرشفة هذا المستخدم، سيستعيد الوصول إلى مساحة الوكالة وسيتم إخطاره عبر البريد الإلكتروني.",
    unarchiveUserSuccessfully: "تم إلغاء أرشفة المستخدم بنجاح",
    userCreatedSuccessfully: "تم إنشاء المستخدم بنجاح",
    userUpdatedSuccessfully: "تم تحديث المستخدم بنجاح",
  },
  userUnarchivedSuccessfully: "تم إلغاء أرشفة المستخدم بنجاح",
  validate: "تحقق",
  worksiteAccessConstraints: "قيود الوصول إلى موقع العمل",
  writeAMessage: "اكتب رسالة...",
  yes: "نعم",
  yesterday: "أمس",
  yourAccount: "حسابك",
  yourClientWillBeNotifiedByEmail: "سيتم إخطار عميلك عبر البريد الإلكتروني.",
  yourOffer: "عرضك",
  yourOrdersAreWaitingForYouLogin: "طلباتك في انتظارك، قم بتسجيل الدخول!",
  yourResourcesWillBeAddedToYourSpaceAfterProcessing: "سيتم إضافة مواردك إلى مساحتك بعد المعالجة",
} as const;

export default AR;
